"use client"

import { useState, useEffect } from "react"
import axios from "axios"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Alert,
  IconButton,
  Typography,
  Autocomplete, // Autocomplete কম্পোনেন্ট ইম্পোর্ট করা হয়েছে
} from "@mui/material"
import { Close as CloseIcon } from "@mui/icons-material"
import BaseURL from "../../api/AppURL";

const AddNsmModal = ({ open, onClose, onSaveSuccess }) => {
  const [nsmName, setnsmName] = useState("")
  const [nsmTeamName, setnsmTeamName] = useState("")
  const [selectedGroup, setSelectedGroup] = useState("") // API এর জন্য group_id
  const [selectedGroupObject, setSelectedGroupObject] = useState(null) // Autocomplete এর জন্য নির্বাচিত গ্রুপ অবজেক্ট
  const [mobileNo, setMobileNo] = useState("")
  const [address, setAddress] = useState("")
  const [groups, setGroups] = useState([])
  const [loadingGroups, setLoadingGroups] = useState(true)
  const [loadingSave, setLoadingSave] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (open) {
      // Modal খোলার সময় ফর্ম এবং মেসেজ রিসেট করুন
      setnsmTeamName("")
      setnsmName("")
      setSelectedGroup("")
      setSelectedGroupObject(null) // Autocomplete অবজেক্ট রিসেট
      setMobileNo("")
      setAddress("")
      setError(null)
      // fetchGroups()
    }
  }, [open])

  // const fetchGroups = async () => {
  //   setLoadingGroups(true)
  //   setError(null)
  //   try {
  //     const token = localStorage.getItem("auth_token")
  //     const response = await axios.get(`${BaseURL}/all/nsmanager`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         Accept: "application/json",
  //       },
  //     })
  //     if (response.data && Array.isArray(response.data.groups)) {
  //       setGroups(response.data.groups)
  //     } else {
  //       setGroups([])
  //       setError("No groups found or invalid response format.")
  //     }
  //   } catch (err) {
  //     console.error("Error fetching groups:", err)
  //     setError("Failed to load groups. Please check your network or API.")
  //   } finally {
  //     setLoadingGroups(false)
  //   }
  // }

  const handleSave = async () => {
    setLoadingSave(true)
    setError(null)

    const token = localStorage.getItem("auth_token")
    if (!token) {
      setError("Authentication token not found. Please log in again.")
      setLoadingSave(false)
      return
    }

    try {
      const response = await axios.post(
        `${BaseURL}/store/nsmanager`,
        {
          nsm_team_name: nsmTeamName,
          ns_manager_name: nsmName,
          // group_id: selectedGroup, 
          mobile_no: mobileNo,
          address: address,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      )

      console.log("API Response on Save:", response.data)

      if (response.data.status === "success") {
        onSaveSuccess(response.data.message || "Nsm added successfully!")
        onClose()
      } else {
        setError(response.data.message || "Failed to add supplier.")
      }
    } catch (err) {
      console.error("Error saving supplier:", err)
      if (err.response && err.response.data && err.response.data.errors) {
        const validationErrors = Object.values(err.response.data.errors).flat().join("\n")
        setError(`Validation Error:\n${validationErrors}`)
      } else if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message)
      } else {
        setError("An unexpected error occurred while saving the supplier.")
      }
    } finally {
      setLoadingSave(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Add National Sales Manager
        </Typography>
        <IconButton aria-label="close" onClick={onClose} sx={{ color: (theme) => theme.palette.grey[500] }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {error && (
          <Alert severity="error" sx={{ mb: 2, whiteSpace: "pre-wrap" }}>
            {error}
          </Alert>
        )}
        <TextField
          label="National Sales Manager Team Name"
          placeholder="National Sales Manager Team Name"
          fullWidth
          margin="normal"
          value={nsmTeamName}
          onChange={(e) => setnsmTeamName(e.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          label="National Sales Manager Name"
          placeholder="National Sales Manager Name"
          fullWidth
          margin="normal"
          value={nsmName}
          onChange={(e) => setnsmName(e.target.value)}
          variant="outlined"
          size="small"
        />

        {/*
        <Autocomplete
          id="select-group-autocomplete"
          options={groups}
          getOptionLabel={(option) => option.name || ""}
          value={selectedGroupObject}
          onChange={(event, newValue) => {
            setSelectedGroupObject(newValue)
            setSelectedGroup(newValue ? newValue.id : "")
          }}
          loading={loadingGroups}
          disabled={loadingGroups}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Group"
              placeholder="Search or Select Group"
              margin="normal"
              variant="outlined"
              size="small"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingGroups ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          noOptionsText={loadingGroups ? "Loading groups..." : "No groups available"}
          sx={{ mt: 1, mb: 1 }}
        /> */}

        <TextField
          label="Mobile No"
          placeholder="Mobile Number"
          fullWidth
          margin="normal"
          value={mobileNo}
          onChange={(e) => setMobileNo(e.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          label="Address"
          placeholder="Enter address"
          fullWidth
          margin="normal"
          multiline
          rows={4}
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          variant="outlined"
          size="small"
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", p: 2 }}>
        <Button variant="contained" onClick={handleSave} disabled={loadingSave} sx={{ minWidth: 100 }}>
          {loadingSave ? <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddNsmModal
